import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaIndustry, FaTrain, FaHeartbeat, FaPlane, FaCar, FaBolt } from 'react-icons/fa';
import PageHero from '../components/PageHero';

const catColor = {
  Industrial: '#16a34a',
  Railway:    '#2563eb',
  Medical:    '#dc2626',
  Defence:    '#7c3aed',
  Automotive: '#d97706',
};

const projects = [
  {
    id:1, cat:'Industrial', icon:<FaIndustry size={18}/>,
    client:'USA Industrial Company (Milton Roy)',
    product:'Chemical Dosing Pump — Box Build',
    desc:'Milton Roy manufactures controlled-volume metering pumps for critical chemical dosing and water treatment. Saalfo handled complete box build including PCBA, wiring harness, and mechanical assembly.',
    scope:['Box Build Assembly','PCBA','Wiring Harness'],
    metrics:[
      { k:'PCBA Produced',        v:'10,000 units' },
      { k:'Wiring Harness',       v:'12,000 units' },
      { k:'Monthly Volume',       v:'1,500 units' },
      { k:'On-Time Delivery',     v:'96%' },
      // { k:'Quality (PPM)',        v:'<250 PPM' },
    ],
    variants:['P+0 (47123)','P+1 (47124)','P+7 (47125)','P+8 (47126)','Grounding Cable Y Assembly'],
  },
  {
    id:2, cat:'Industrial', icon:<FaBolt size={18}/>,
    client:'Indian IoT OEM',
    product:'Smart Energy Meters (IoT / Bluetooth)',
    desc:'Complete product-level engagement — PCBA, wiring harness, box build, and final testing for three varieties of smart energy meters with IoT and Bluetooth connectivity.',
    scope:['PCBA','Wiring Harness','Box Build','Final Testing'],
    metrics:[
      { k:'Total Meters',         v:'>20 Million' },
      { k:'Monthly Volume',       v:'125,000 units' },
      { k:'Daily Volume',         v:'3,000–5,000 units' },
      { k:'On-Time Delivery',     v:'96.7%' },
      // { k:'Quality (PPM)',        v:'<750 PPM' },
    ],
    variants:['1Ph Energy Meter','1Ph Din Meter','3Ph Din Meter'],
  },
  {
    id:3, cat:'Railway', icon:<FaTrain size={18}/>,
    client:'Japanese Railway Company',
    product:'Railway Signalling PCBA & Wiring Harness',
    desc:'Safety-critical PCBA and wiring harness for railway signalling systems — manufactured to demanding Japanese quality standards with full traceability.',
    scope:['PCBA','Wiring Harness'],
    metrics:[
      { k:'PCBA Produced',        v:'3,000 units' },
      { k:'Wiring Harness',       v:'4,000 sets' },
      { k:'Monthly Volume',       v:'1,800 units' },
      { k:'On-Time Delivery',     v:'98%' },
      // { k:'Quality (PPM)',        v:'<500 PPM' },
    ],
    variants:['PD Card 21KHz','PD Card 25KHz','G36R Dual Display Reset PCBA','Relay Drive Card','SM CPU / Event Logger Card','Cable Bunching — Mother Board to MS Coupler'],
  },
  {
    id:4, cat:'Railway', icon:<FaTrain size={18}/>,
    client:'European Railway Company',
    product:'Axle Counting System — Full Box Build',
    desc:'Complete PCBA, wiring harness, and box build integration for a European axle counting system. One of Saalfo\'s highest on-time delivery performance programmes.',
    scope:['PCBA','Wiring Harness','Box Build Integration'],
    metrics:[
      { k:'PCBA Variants',        v:'13 types' },
      { k:'Harness Sets',         v:'2 types' },
      { k:'Box Build Types',      v:'2 types' },
      { k:'Monthly Volume',       v:'4,900 units' },
      { k:'On-Time Delivery',     v:'99%' },
      // { k:'Quality (PPM)',        v:'<500 PPM' },
    ],
    variants:['Axle Counting BO23','VUR Unit'],
  },
  {
    id:5, cat:'Railway', icon:<FaTrain size={18}/>,
    client:'Austrian Railway Company',
    product:'Axle Counting Cubical Wiring Harness',
    desc:'Precision wiring harness for axle counting cubicles — complex multi-bundle cable assembly manufactured for safety-critical railway infrastructure.',
    scope:['Wiring Harness'],
    metrics:[
      { k:'Product Type',         v:'Cubicle wiring harness' },
      { k:'Complexity',           v:'High-mix multi-bundle' },
      { k:'Segment',              v:'Railway — Safety-critical' },
    ],
    variants:['Axle Counting Cubicle Wiring'],
  },
  {
    id:6, cat:'Medical', icon:<FaHeartbeat size={18}/>,
    client:'Medical OEM',
    product:'Medical Device — Engineering & PCBA',
    desc:'Engineering and development (Proto / NPI Build) and PCBA for a medical device — manufactured under Class II & III approved processes at Saalfo\'s Mysore facility.',
    scope:['Engineering & Development','NPI Build','PCBA'],
    metrics:[
      { k:'Facility Approval',    v:'Class II & III' },
      { k:'Upcoming Cert',        v:'ISO 13485 — 2026-27' },
      { k:'Engagement',           v:'Full NPI to PCBA' },
    ],
    variants:['Medical Device PCBA'],
  },
  {
    id:7, cat:'Defence', icon:<FaPlane size={18}/>,
    client:'Defence OEM',
    product:'Drone Power Card',
    desc:'Full DFX design, engineering, NPI, PCBA, and wiring harness for a drone power card — complete from concept to prototype in-house at Saalfo.',
    scope:['Design (DFX)','NPI Build','PCBA','Wiring Harness'],
    metrics:[
      { k:'Engagement Type',      v:'Design to Production' },
      { k:'Platform',             v:'Defence / Unmanned' },
      { k:'Scope',                v:'Full DFX + PCBA + Harness' },
    ],
    variants:['Drone Power Card'],
  },
  {
    id:8, cat:'Defence', icon:<FaPlane size={18}/>,
    client:'Defence OEM',
    product:'Drone Power Distribution Unit',
    desc:'Complete power distribution unit for drone platforms — DFX design, NPI, PCBA, and wiring harness delivered under stringent defence-grade requirements and traceability.',
    scope:['Design (DFX)','NPI Build','PCBA','Wiring Harness'],
    metrics:[
      { k:'Product',              v:'Power Distribution Unit' },
      { k:'Platform',             v:'Defence Drone' },
      { k:'Scope',                v:'Full turnkey' },
    ],
    variants:['Power Distribution Unit'],
  },
  {
    id:9, cat:'Automotive', icon:<FaCar size={18}/>,
    client:'Automotive OEM',
    product:'Voltage Regulator — Design & PCBA',
    desc:'Design (DFX), engineering, NPI, and PCBA for an automotive voltage regulator — from initial design through prototype and production at Saalfo.',
    scope:['Design (DFX)','NPI Build','PCBA'],
    metrics:[
      { k:'Product',              v:'Voltage Regulator' },
      { k:'Segment',              v:'Automotive' },
      { k:'Scope',                v:'DFX + NPI + PCBA' },
    ],
    variants:['Regulator PCBA'],
  },
];

const cats = ['All','Industrial','Railway','Medical','Defence','Automotive'];

export default function Projects() {
  const [active, setActive] = useState('All');
  const filtered = active === 'All' ? projects : projects.filter(p => p.cat === active);

  return (
    <div>
      <PageHero
        chip="Key Projects"
        title="Proven Performance Across Industries"
        subtitle="Real programmes delivered for global OEMs — from 10-unit NPI builds to 20 million+ unit mass production runs."
      />

      <section className="sec">
        <div
  className="wrap"
  style={{
    width: '100%',
    maxWidth: '100%',
    padding: '0 24px'
  }}
>

          {/* Filter tabs */}
          <div style={{ display:'flex', flexWrap:'wrap', gap:8, marginBottom:40 }}>
            {cats.map(c => (
              <button key={c} onClick={() => setActive(c)} style={{
                padding:'8px 20px', borderRadius:8, cursor:'pointer',
                border: active === c ? '2px solid #5cb85c' : '1px solid #e2e8f0',
                background: active === c ? '#eaf6ea' : '#fff',
                color: active === c ? '#3d8b3d' : '#64748b',
                fontWeight:600, fontSize:13, transition:'all .18s',
              }}>
                {c}
              </button>
            ))}
          </div>

          {/* Cards */}
          <div style={{ display:'flex', flexDirection:'column', gap:20 }}>
            {filtered.map(p => (
              <div key={p.id} className="card" style={{ padding:'28px 30px' }}>
                <div style={{ display:'flex', gap:20, flexWrap:'wrap' }}>

                  {/* Left */}
                  <div style={{ flex:'1 1 300px' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:12 }}>
                      <div style={{ width:32, height:32, borderRadius:8,
                        background:`${catColor[p.cat]}14`,
                        display:'flex', alignItems:'center', justifyContent:'center',
                        color:catColor[p.cat] }}>
                        {p.icon}
                      </div>
                      <span style={{ fontSize:12, fontWeight:600, color:catColor[p.cat],
                        padding:'3px 10px', borderRadius:100, background:`${catColor[p.cat]}12` }}>
                        {p.cat}
                      </span>
                    </div>
                    <p style={{ fontSize:12, color:'#94a3b8', marginBottom:5, fontWeight:600, letterSpacing:'.06em', textTransform:'uppercase' }}>
                      {p.client}
                    </p>
                    <h3 style={{ fontFamily:'Rajdhani', fontSize:22, fontWeight:700, color:'#1a1a2e', marginBottom:10 }}>
                      {p.product}
                    </h3>
                    <p style={{ fontSize:14, color:'#64748b', lineHeight:1.7, marginBottom:14 }}>{p.desc}</p>
                    <div style={{ display:'flex', flexWrap:'wrap', gap:7, marginBottom:14 }}>
                      {p.scope.map(s => <span key={s} className="badge">{s}</span>)}
                    </div>
                    {p.variants && (
                      <div>
                        <p style={{ fontSize:12, fontWeight:600, color:'#475569', marginBottom:6 }}>Products / Variants:</p>
                        <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
                          {p.variants.map(v => <span key={v} className="tag">{v}</span>)}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Right — metrics */}
                  <div style={{ flexShrink:0, minWidth:190 }}>
                    <p style={{ fontSize:11, fontWeight:600, color:'#94a3b8', marginBottom:10, letterSpacing:'.08em', textTransform:'uppercase' }}>
                      Programme Metrics
                    </p>
                    <div style={{ display:'flex', flexDirection:'column', gap:7 }}>
                      {p.metrics.map(m => (
                        <div key={m.k} style={{ display:'flex', justifyContent:'space-between', gap:14,
                          padding:'8px 12px', borderRadius:8, background:'#f8fafb', border:'1px solid #f1f5f9' }}>
                          <span style={{ fontSize:12, color:'#94a3b8' }}>{m.k}</span>
                          <span style={{ fontSize:13, fontWeight:700, color:'#3d8b3d', fontFamily:'JetBrains Mono' }}>{m.v}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="sec-sm bg-green" style={{ textAlign:'center' }}>
        <div
  className="wrap"
  style={{
    width: '100%',
    maxWidth: '100%',
    padding: '0 24px'
  }}
>
          <h2 className="h2" style={{ marginBottom:10 }}>Have a similar project?</h2>
          <p className="sub" style={{ margin:'0 auto 26px' }}>Let's explore how Saalfo Tech can support you.</p>
          <Link to="/contact" className="btn btn-primary">Start a Conversation</Link>
        </div>
      </section>
    </div>
  );
}
